<template>
    <div class="ReChatMessage">
        <base-dropdown title-classes="no-border">

            <template slot="title-container" style="display: none">
                <div class="ReChatMessage_wrapper">

                    <div class="userPic">
                        <img :src="userIcon" alt="ava" class="avatar" />
                    </div>
                    <div class="commentCol otherU lightTheme">
                        <div class="comHeader">
                            <p class="userName mb-0 text-success">{{userName}}</p>
                            <!-- должно быть {{comment.userName}}
                            if it's me, then 'userName' display: none-->     
                            <p class="comDate">{{comDate}}</p>
                            <!--{{comment.comDate}}-->     
                
                        </div>

                        <a href="#" class="replyMsg">
                            <div class="replyMsg_wrapper">
                                <div class="replybar"></div>
                                <div class="col">
                                    <p class="userName mb-0 text-info">{{userName}}</p>
                                    <p class="comText">{{comText}}</p><!--{{comment.comText}}-->
                                </div>
                            </div>
                        </a>    

                        <div class="messageBody">
                            <p class="comText">{{comText}}</p><!--{{comment.comText}}-->
                            <p class="comText">{{comText}}</p><!--{{comment.comText}}-->
                            <p class="comText">{{comText}}</p><!--{{comment.comText}}-->
                            <div class="photoBlock mt-2">
                                <div class="messagePhoto mb-3">
                                    <img :src="src" alt="">
                                </div>
                            </div>
                        </div>             
                    </div>
                </div><!--ReChatMessage_wrapper-->

            </template>

            <a class="dropdown-item">Ответить</a>
            <a class="dropdown-item">Копировать</a>
            <a class="dropdown-item">Переслать</a>
            <a class="dropdown-item">Добавить в закладки</a>
            <a class="dropdown-item">Редактировать</a>
            <a class="dropdown-item">Удалить</a>
            <!--появляется для тех, у кого есть права на редактирование канала-->
        </base-dropdown>

    </div>
</template>

<script>

export default {
    name: 'ReChatMessage',
    components: {

    },
    props: {
        counter: String,
        findId: {
            type: String,
            default: '',
        },
        userIcon: {
            type: String,
            default: "/img/Default_userpic_M.svg"
        },
        userName: {
            type: String,
            default: "Имя Фамилия"
        },
        comDate: {
            type: String,
            default: "17:07"
        },
        comText: {
            type: String,
            default: "Текст сообщения Текст сообщения"
        },
        src: {
            type: String,
            default: '',
        }

    },
    data () {
        return {
            ver: 1,
        }
    },
    computed: {

    },
    methods: {

    },
}
</script>
<style scoped>

.ReChatMessage {max-width: 500px;}

.ReChatMessage_wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
}
.userPic {margin: 0 10px 0 0;}
.userPic img {max-width: unset;}
.userPic .avatar {
  width: 30px;
  height: 30px;
  object-fit: contain;
  margin-bottom: 0;
  background-color: transparent;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.commentCol {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  padding: 15px;  
  border-radius: 0.2857rem;
  /* if it's me  background-color: #00566D;*/
}
.commentCol.self {background-color: #00566D;}
.commentCol.otherU {background-color: #191f31;}
.white-content .card:not(.card-white) .otherU.lightTheme {background: #e2e4ed!important; box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08)!important;}
.white-content .card:not(.card-white) .self.lightTheme {background: #d3edf4!important; box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08)!important;}

.replyMsg {
	display: block;
	margin: 2px;
	overflow: hidden;
	color: inherit;
    text-decoration: none;
}
.replyMsg_wrapper {
	position: relative;
    display: flex;
    overflow: hidden;
    max-height: 50px;
}
.replybar {
	background: linear-gradient(180deg, #01B0E0 0%, #00DCB1 100%) !important;
    height: 85%;
    width: 2px;
    position: absolute;
}

.messageBody {display: flex; flex-direction: column;}
.photoBlock {display: flex; flex-wrap: wrap;}
.messagePhoto {
    max-width: 400px;
}
.messagePhoto:not(:last-child) {margin-right: 15px;}
.messagePhoto img {width: 100%;}
.comDate {opacity: 0.4;}
.comHeader {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

/*===expand button===============================*/
.replyBtn {
  background-color: transparent;
  border: none;
  outline: none;
  color: #9e77f3;
  padding-left: 0;
}
.replyBtn:hover {color: #01b0e0;}

/*===dropdown===============================*/
.ReChatMessage >>> .dropdown-menu {
    right: 5%!important;
    top: 30%!important;
}
.ReChatMessage >>> .dropdown-menu::before {display: none;}
</style>
